import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EChartsOption } from 'echarts';
import { NumberSuffixPipe } from 'src/app/core/filters/numberSuffix-pipe';
import { LowerBound } from 'src/app/core/services/lowerBound.service';
import { ChartService } from 'src/app/core/services/waterfallChart.service';

@Component({
  selector: 'app-price-bridge',
  templateUrl: './price-bridge.component.html',
  styleUrls: ['./price-bridge.component.scss']
})
export class PriceBridgeComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() totalPricePercVal: any;
  @Output() chartClick: any = new EventEmitter<any>();

  colors: any = [];
  chartOption: EChartsOption = {};
  min: number = 0;
  salesData: any = [];
  start: any = [];
  onquote_sum: any = [];
  positive: any = [];
  negative: any = [];
  a: any = [];
  totalPriceChart = {};
  totalPriceImpact: any[] = [];
  totalPrice_positive: any = [];
  totalPrice_negative: any = [];
  totalPrice_data: any = [];
  salesBreakDown = {};
  salesBreakChart = {};
  salesBreakImpact: any[] = [];
  totalVolume_positive: any = [];
  totalVolume_negative: any = [];
  totalVolume_data: any = [];

  max: number = 0;
  reduce: number = 0;
  startingPoint: number = 0;
  base: number = 0;

  constructor(
    private chart: ChartService,
    private lowerBound: LowerBound
  ) { }

  ngOnInit(): void {
    // this.getChart();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      this.getChart();
    }
  }
  getChart() {
    this.salesData = this.data.priceRealization;
    let data: any[] = [];
    data[0] = this.salesData.base_sales;
    data[1] = this.salesData.comparable_base;
    data[2] = this.salesData.total_price_impact;
    data[3] = this.salesData.comparable_current;
    data[4] = this.salesData.financial_adjustments;
    data[5] = this.salesData.curent_sales;
    // data[6] = this.salesData.sales_2023;
    this.startingPoint = this.lowerBound.calcLowerBound(data);
    // if ( this.salesData.sales_2023 < this.base){
    //   this.startingPoint = this.salesData.sales_2023;
    // }
    // else{
    //   this.startingPoint = this.lowerBound.calcLowerBound(data);
    // }
    if (this.startingPoint >= 0) {
      this.base = this.startingPoint;
    } else {
      this.base = 0;
    }
    const waterfallData = [
      [
        'barLabel',
        'barStartValue',
        'barEndValue',
        'referenceDatapoint',
        'index',
      ],
      [
        'Base Sales',
        this.base, this.salesData.base_sales, 1, 0
      ],
      [
        'Comparable Base',
        this.base,

        this.salesData.comparable_base, 1, 0 
      ],
      ['Total Price Impact',
        // this.salesData.base_sales +
        this.salesData.comparable_base,

        // this.salesData.base_sales +
        this.salesData.comparable_base +
        this.salesData.total_price_impact,
      ],
      [
        'Comparable Current',
        this.base,

        
        this.salesData.comparable_current, 1, 0
      ],
      [
        'Finacial Adj.',
        // this.salesData.base_sales +
        // this.salesData.comparable_base +
        // this.salesData.total_price_impact +
        this.salesData.comparable_current,

        // this.salesData.base_sales +
        // this.salesData.comparable_base +
        // this.salesData.total_price_impact +
        this.salesData.comparable_current + 
        this.salesData.financial_adjustments,
      ],
      [
        'Current Sales',
        
        this.base, this.salesData.curent_sales, 1, 0
      ],

    ];
    // const waterfallData = [
    //   [
    //     'barLabel',
    //     'barStartValue',
    //     'barEndValue',
    //     'referenceDatapoint',
    //     'index',
    //   ],
    //   [
    //     '2022 Sales',
    //     this.base, this.salesData.sales_2022, 1, 0
    //   ],
    //   [
    //     '2022 Sales Volume \n Neutralized',
    //     this.salesData.sales_2022,

    //     this.salesData.sales_2022 +
    //     this.salesData.sales_volume_neutralized_2022,
    //   ],
    //   ['Total Price Impact',
    //     this.salesData.sales_2022 +
    //     this.salesData.sales_volume_neutralized_2022,

    //     this.salesData.sales_2022 +
    //     this.salesData.sales_volume_neutralized_2022 +
    //     this.salesData.total_price_impact,
    //   ],
    //   [
    //     'Mix Impact',
    //     this.salesData.sales_2022 +
    //     this.salesData.sales_volume_neutralized_2022 +
    //     this.salesData.total_price_impact,

    //     this.salesData.sales_2022 +
    //     this.salesData.sales_volume_neutralized_2022 +
    //     this.salesData.total_price_impact +
    //     this.salesData.mix_impact,
    //   ],
    //   [
    //     'Volume Impact',
    //     this.salesData.sales_2022 +
    //     this.salesData.sales_volume_neutralized_2022 +
    //     this.salesData.total_price_impact +
    //     this.salesData.mix_impact,

    //     this.salesData.sales_2022 +
    //     this.salesData.sales_volume_neutralized_2022 +
    //     this.salesData.total_price_impact +
    //     this.salesData.mix_impact +
    //     this.salesData.vol_imp,
    //   ],

    //   // [
    //   //   '2023 Sales Volume \n Neutralized',
    //   //   this.salesData.sales_2022 +
    //   //   this.salesData.sales_volume_neutralized_2022 +
    //   //   this.salesData.total_price_impact +
    //   //   this.salesData.mix_impact +
    //   //   this.salesData.vol_imp,

    //   //   this.salesData.sales_2022 +
    //   //   this.salesData.sales_volume_neutralized_2022 +
    //   //   this.salesData.total_price_impact +
    //   //   this.salesData.mix_impact +
    //   //   this.salesData.vol_imp +
    //   //   this.salesData.sales_volume_neutralized_2023, 1, 0
    //   // ],
    //   [
    //     '2023 Sales Volume \n Neutralized',
        
    //     this.base,  this.salesData.sales_volume_neutralized_2023, 1, 0
    //   ],

    //   [
    //     '2023 Sales', this.base, this.salesData.sales_2023, 1, 0
    //   ],
    // ];
    this.chartOption = this.chart.loadWaterFall(
      waterfallData,
      this.startingPoint,
      ''
    );
    let totalprice: any[] = [];

    totalprice[0] = this.data.priceImpact.pricerealizedby_pricespec_prices;
    totalprice[1] = this.data.priceImpact.comparable_customer_specs;
    totalprice[2] = this.data.priceImpact.unmapped;
    totalprice[3] = this.data.priceImpact.total_price_impact;

    this.totalPriceImpact = totalprice;
    const totalPrice = [
      [
        'barLabel',
        'barStartValue',
        'barEndValue',
        'referenceDatapoint',
        'index',
      ],
      ['Price Realized \n by Price spec \n prices', 1, this.totalPriceImpact[0], 1, 0],
      [
        'Comparable \n Customer \n spec',
        this.totalPriceImpact[0],
        this.totalPriceImpact[0] + this.totalPriceImpact[1],
      ],
      [
        'Unmapped',
        this.totalPriceImpact[0] + this.totalPriceImpact[1],
        this.totalPriceImpact[0] +
        this.totalPriceImpact[1] +
        this.totalPriceImpact[2],
      ],

      ['Total Price\nImpact', 1, this.totalPriceImpact[3], 1, 0],
    ];



    this.totalPriceChart = {
      tooltip: {
        show: true,
        trigger: 'item',
        borderColor: 'white',
        responsive: true,
        backgroundColor: '#fafcfe',
        formatter: (params) => {
          const labelData = (params.data[2] - params.data[1]).toLocaleString(
            undefined,
            {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }
          );

          return params.data[0] + '<br/>' + 'Value' + ' : ' + labelData;
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      dataset: {
        source: totalPrice,
      },
      xAxis: {
        type: 'category',

        splitLine: { show: false },

        axisLabel: {
          interval: 0,
          fontSize: 12,
          color: 'black',
          fontWeight: 500,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
      yAxis: {
        type: 'value',
        splitLine: { show: true },
        axisLabel: {
          formatter: function (xAxis, d) {
            return NumberSuffixPipe.prototype.transform(xAxis, 1);
          },
          align: 'center',
          fontSize: 12,
        },
        axisLine: {
          lineStyle: {
            type: 'dotted',
          },
        },
      },
      series: [
        {
          type: 'custom',
          label: {
            show: true,
            position: 'top',
            color: 'black',
            fontWeight: 'bold',
            fontSize: 12,

            formatter: (params) => {
              const labelData = params.data[2] - params.data[1];

              return NumberSuffixPipe.prototype.transform(labelData, 1);
            },
          },

          datasetIndex: 0,
          encode: {
            y: 2,
          },

          renderItem: (params, api) => {
            const dataIndex = api.value(0);
            const barStartValue = api.value(1);
            const barEndValue = api.value(2);
            const startCoord = api.coord([dataIndex, barStartValue]);
            const endCoord = api.coord([dataIndex, barEndValue]);

            const rectWidth = 50;
            const rectMinHeight = 0;
            let rectHeight = 0;
            if (api.value(2) !== 0) {
              rectHeight = startCoord[1] - endCoord[1];
            }
            const style = api.style();
            if (rectHeight < 0) {
              style.fill = '#FF0404'; // red (negativeColor)
            } else {
              style.fill = '#009b19'; // green (positiveColor)
            }
            const referenceData = api.value(3);
            if (referenceData === 1) {
              style.fill = '#c4c4c4'; // gray (referenceColor)
            }
            rectHeight = rectHeight === 0 ? rectMinHeight : rectHeight;
            const rectItem = {
              type: 'rect',
              shape: {
                x: endCoord[0] - rectWidth / 2,
                y: endCoord[1],
                width: rectWidth,
                height: rectHeight,
                // r: 5,
              },
              style: style,
            };
            return rectItem;
          },
        },
      ],
    };
    let salesBreak: any[] = [];
    salesBreak[0] = this.data.volumeImpact.pricerealizedby_pricespec_prices;
    salesBreak[1] = this.data.volumeImpact.comparable_customer_specs;
    salesBreak[2] = this.data.volumeImpact.unmapped;
    salesBreak[3] = this.data.volumeImpact.sales_2023;
    this.salesBreakImpact = salesBreak;
    const salesBreakDown = [
      [
        'barLabel',
        'barStartValue',
        'barEndValue',
        'referenceDatapoint',
        'index',
      ],
      ['Price Realization \n by Price \n spec prices', 0, this.salesBreakImpact[0], 1, 0],
      [
        'Comparable \n Customer \n specs',

        this.salesBreakImpact[0],
        this.salesBreakImpact[0] + this.salesBreakImpact[1],
      ],
      [
        'Unmapped',

        this.salesBreakImpact[0] + this.salesBreakImpact[1],
        this.salesBreakImpact[0] + this.salesBreakImpact[1] + this.salesBreakImpact[2],
      ],

      ['2023 Sales', 0, this.salesBreakImpact[3], 1, 0],
    ];

    this.salesBreakChart = {
      tooltip: {
        show: true,
        trigger: 'item',
        borderColor: 'white',
        responsive: true,
        backgroundColor: '#fafcfe',
        formatter: (params) => {
          const labelData = (params.data[2] - params.data[1]).toLocaleString(
            undefined,
            {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }
          );

          return params.data[0] + '<br/>' + 'Value' + ' : ' + labelData;
        },
      },

      grid: {
        left: '4%',
        right: '3%',
        bottom: '3%',
        containLabel: true,
      },
      dataset: {
        source: salesBreakDown,
      },
      xAxis: {
        type: 'category',
        splitLine: { show: false },

        axisLabel: {
          interval: 0,
          //rotate: 5,
          fontSize: 12,
          color: 'black',
          fontWeight: 500,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
      yAxis: {
        type: 'value',
        splitLine: { show: true },
        axisLabel: {
          formatter: function (xAxis, d) {
            return NumberSuffixPipe.prototype.transform(xAxis, 1);
          },
          align: 'center',
          fontSize: 12,
        },
        axisLine: {
          lineStyle: {
            type: 'dotted',
          },
        },
      },
      series: [
        {
          type: 'custom',
          label: {
            show: true,
            position: 'top',
            color: 'black',
            fontWeight: 'bold',
            fontSize: 12,

            formatter: (params) => {
              const labelData = params.data[2] - params.data[1];

              return NumberSuffixPipe.prototype.transform(labelData, 1);
            },
          },

          datasetIndex: 0,
          encode: {
            y: 2,
          },

          renderItem: (params, api) => {
            const dataIndex = api.value(0);
            const barStartValue = api.value(1);
            const barEndValue = api.value(2);
            const startCoord = api.coord([dataIndex, barStartValue]);
            const endCoord = api.coord([dataIndex, barEndValue]);

            const rectWidth = 50;
            const rectMinHeight = 0;
            let rectHeight = 0;
            if (api.value(2) !== 0) {
              rectHeight = startCoord[1] - endCoord[1];
            }
            const style = api.style();
            if (rectHeight < 0) {
              style.fill = '#FF0404'; // red (negativeColor)
            } else {
              style.fill = '#009b19'; // green (positiveColor)
            }
            const referenceData = api.value(3);
            if (referenceData === 1) {
              style.fill = '#c4c4c4'; // gray (referenceColor)
            }
            rectHeight = rectHeight === 0 ? rectMinHeight : rectHeight;
            const rectItem = {
              type: 'rect',
              shape: {
                x: endCoord[0] - rectWidth / 2,
                y: endCoord[1],
                width: rectWidth,
                height: rectHeight,
                // r: 5,
              },
              style: style,
            };
            return rectItem;
          },
        },
      ],
    };
  }
  onChartClick(event) {
    this.chartClick.emit(event);
  }

}
